import { computed, inject } from '@angular/core';
import {
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { IGeneralOptionsTasks } from '@kinet-open-network/shared/data-access/model';
import {
  patchState,
  signalStore,
  signalStoreFeature,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';
import { TasksService } from '../services/tasks.service';

interface TasksOptionsStateSlice {
  settings: IGeneralOptionsTasks | null;
}

export function withTasksOptions() {
  return signalStoreFeature(
    withState<TasksOptionsStateSlice>({
      settings: null,
    }),
    withComputed(({ settings: options }) => ({
      subtaskOptions: computed(() => options()?.subtaskTypes || {}),
    })),
    withMethods((store, customerService = inject(TasksService)) => ({
      loadTasksOptions: async () => {
        try {
          const options = await firstValueFrom(
            customerService.getTasksOptions(),
          );
          patchState(store, { settings: options });
        } catch (err) {
          patchState(store, { settings: null });
          throw err;
        }
      },
    })),
  );
}

export const TasksStore = signalStore(
  { protectedState: false },
  withResourceState(TasksService),
  withExport(TasksService),
  withTasksOptions(),
);
